
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Noel() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  useEffect(() => {
    // SEO JSON-LD pour la page collection Noël
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Collection Noël - Anges artisanaux | Les Carnets de Lolotte",
      "description": "Découvrez notre collection spéciale Noël d'anges artisanaux en papier plié. Créations uniques faites main pour une décoration de Noël poétique.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/noel`,
      "mainEntity": {
        "@type": "ItemList",
        "name": "Collection Noël - Anges de Lolotte",
        "numberOfItems": 6,
        "itemListElement": [
          {
            "@type": "Product",
            "name": "Ange à poser – 25 cm",
            "category": "Décoration de Noël",
            "offers": {
              "@type": "Offer",
              "price": "20",
              "priceCurrency": "EUR"
            }
          },
          {
            "@type": "Product",
            "name": "Ange Joyeux Cœur",
            "category": "Décoration de Noël",
            "offers": {
              "@type": "Offer",
              "price": "4",
              "priceCurrency": "EUR"
            }
          }
        ]
      },
      "seasonalEvent": {
        "@type": "Event",
        "name": "Noël",
        "description": "Collection spéciale pour les fêtes de Noël"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    // Mise à jour des meta tags
    document.title = "Collection Noël - Anges artisanaux en papier plié | Les Carnets de Lolotte";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Découvrez notre collection spéciale Noël d\'anges artisanaux en papier plié. Créations uniques faites main pour une décoration de Noël poétique et authentique.');
    }

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const products = [
    {
      id: 1,
      name: 'Ange à poser – 25 cm',
      price: '30€',
      description: 'Poétique et luminous, cet ange à poser est entièrement réalisé à la main à partir d\'un livre recyclé. Chaque pli, chaque détail – des ailes jusqu\'à la petite étoile dorée – est façonné avec soin et amour 💫',
      dimensions: '25 cm de hauteur',
      colors: 'naturel avec étoile dorée',
      materials: 'papier recyclé, ruban et étoile dorée',
      image: 'https://public.readdy.ai/ai/img_res/7c861076-4330-401d-9c9f-9d520b2e9bf0.png',
      link: '/produit-ange-a-poser-25cm',
      badge: 'Pièce unique ✨',
      badgeColor: 'bg-[#C49B86]'
    },
    {
      id: 2,
      name: 'Ange "Joyeux Cœur"',
      price: '4€',
      description: 'Le petit ange au sourire radieux ✨ Réalisé à partir de pages de livre pliées à la main, cet ange illumine les cœurs avec son visage joyeux.',
      dimensions: 'environ 8 cm (hors ficelle)',
      colors: 'naturel avec ficelle',
      materials: 'pages de livre recyclées, ficelle naturelle',
      image: 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/9ca0f2dee5922ad907a452879600467c.png',
      link: '/produit-ange-joyeux-coeur',
      badge: 'Série limitée 🎄',
      badgeColor: 'bg-[#E8CBA8]'
    },
    {
      id: 3,
      name: 'Ange "Rêve Doux"',
      price: '4€',
      description: 'Le petit ange endormi, plein de tendresse 🌙 Avec ses joues rosées et ses yeux fermés, cet ange semble rêver de lumière.',
      dimensions: 'environ 8 cm (hors ficelle)',
      colors: 'naturel avec ficelle',
      materials: 'pages de livre recyclées, ficelle naturelle',
      image: 'https://public.readdy.ai/ai/img_res/5d6e1851-3bb6-4061-970b-fd2625a28c0d.png',
      link: '/produit-ange-reve-doux',
      badge: 'Série limitée 🎄',
      badgeColor: 'bg-[#E8CBA8]'
    },
    {
      id: 4,
      name: 'Ange "Sérénité"',
      price: '4€',
      description: 'L\'ange discret et lumineux ☀️ Simplicité, pureté et paix intérieure : cet ange porte une expression douce et apaisante.',
      dimensions: 'environ 8 cm (hors ficelle)',
      colors: 'naturel avec ficelle',
      materials: 'pages de livre recyclées, ficelle naturelle',
      image: 'https://public.readdy.ai/ai/img_res/744b7b75-1b4f-49c2-a689-d5bb175d844e.png',
      link: '/produit-ange-serenite',
      badge: 'Série limitée 🎄',
      badgeColor: 'bg-[#E8CBA8]'
    },
    {
      id: 5,
      name: 'Sapin de noël ✨',
      price: '30 €',
      description: "🌲 Quand les pages se transforment en magie de Noël... Ces sapins artisanaux apportent une touche féerique et poétique à votre décoration.",
      dimensions: '18 cm',
      colors: 'naturel avec dentelle blanche',
      materials: 'pages de livres anciens pliées, pompon coloré, base stable',
      image: 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/b25886b6d5302fa4fce5dc966e858d39.png',
      link: '/produit-sapin-noel-livre-plie',
      badge: 'Nouveau 💫',
      badgeColor: 'bg-[#FFF8F5] text-[#C49B86]'
    },
    {
      id: 7,
      name: 'Sapin lumineux doré – Livre plié',
      price: '30 €',
      description: "✨ Sapin lumineux entièrement réalisé à la main en livre plié. Mini guirlande LED intégrée pour apporter une lumière douce et chaleureuse. Un élément poétique idéal pour illuminer votre décoration de Noël.",
      dimensions: '25 cm',
      colors: 'naturel avec ruban doré',
      materials: 'pages de livres anciens pliées, ruban doré satiné, LED intégrée',
      image: 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/3eac711adf0e5d03db76dab7cee730d9.png',
      link: '/produit-sapin-lumineux-dore',
      badge: 'Nouveau ✨',
      badgeColor: 'bg-[#C49B86] text-white'
    },
    {
      id: 6,
      name: 'Lot de 3 Anges "Joyeux Cœur"',
      price: '10€',
      description: '😇 Le trio du bonheur et de la lumière ✨ Ces trois petits anges apportent une note tendre et lumineuse à votre décoration de Noël.',
      dimensions: 'environ 8 cm chacun (hors ficelle)',
      colors: 'naturel avec ficelle',
      materials: 'pages de livres anciens recyclés, ficelle naturelle',
      image: 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/19d4a92b8550e0eaf575afccfa540ece.png',
      link: '/produit-lot-3-anges-joyeux-coeur',
      badge: 'Nouveau 💫',
      badgeColor: 'bg-[#FFF8F5] text-[#C49B86]'
    }
  ];

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleProductClick = (product: any) => {
    if (product.link) {
      window.REACT_APP_NAVIGATE(product.link);
    }
  };

  // Assume handleAddToCart is defined elsewhere or will be added separately

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      {/* Hero Section */}
      <header 
        className="relative py-20 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(248,237,234,0.8), rgba(248,237,234,0.8)), url('https://public.readdy.ai/ai/img_res/eae549571d86782c34f4229f2e31c30c.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-6xl md:text-7xl font-bold mb-6 text-[#B97A72]" style={{ fontFamily: 'Allura, cursive' }}>
            Les Anges de Lolotte
          </h1>
          <h2 className="text-3xl md:text-4xl font-light mb-8 text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Collection spéciale Noël 🎄
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg md:text-xl leading-relaxed mb-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Quand vient Noël, l'atelier des Carnets de Lolotte s'illumine de douceur et de lumière.
            </p>
            <p className="text-lg md:text-xl leading-relaxed mb-4 text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              De petits anges prennent vie entre mes mains, pliés dans les pages des livres.
              Chacun est porteur de tendresse et d'esprit de fête.
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              À suspendre au sapin, à offrir, ou à poser simplement sur une table,
              ces créations artisanales apportent une touche d'âme et de poésie à la magie de Noël 🎄
            </p>
          </div>
        </div>
      </header>

      {/* Products Section */}
      {/* <main className="py-20 bg-[#FAF9F8]" data-product-shop>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
              Nos créations de Noël
            </h2>
            <p className="text-lg text-[#6B5E5A] max-w-2xl mx-auto" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Des créations uniques, faites main avec amour et patience
            </p>
          </div>

          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
              😇 Nos Anges de Noël
            </h2>
            <p className="text-[#6B5E5A] text-lg max-w-2xl mx-auto" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Messagers de tendresse et de lumière
            </p>
          </div>

          <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-6xl mx-auto">
            {products.map((product) => (
              <article key={product.id} className="bg-white rounded-2xl shadow-lg border-2 border-[#F8EDEA] overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-105">
                <div className="relative">
                  <div 
                    className="aspect-square overflow-hidden cursor-pointer" 
                    onClick={() => handleProductClick(product)}
                  >
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain bg-[#F3D9D9] hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className={`absolute top-3 left-3 ${product.badgeColor} text-white px-3 py-1 rounded-full text-sm font-medium shadow-lg hover:scale-105 transition-transform duration-200`} style={{ fontFamily: 'Playfair Display, serif' }}>
                    {product.badge}
                  </div>
                </div>

                <div className="p-8">
                  <h3 className="text-2xl font-semibold text-[#6B5E5A] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {product.name}
                  </h3>
                  <p className="text-[#6B5E5A] mb-6 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {product.description}
                  </p>
                  
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center">
                      <span className="font-medium text-[#B97A72] w-24" style={{ fontFamily: 'Playfair Display, serif' }}>Taille :</span>
                      <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>{product.dimensions}</span>
                    </div>
                    <div className="flex items-center">
                      <span className="font-medium text-[#B97A72] w-24" style={{ fontFamily: 'Playfair Display, serif' }}>Matière :</span>
                      <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>{product.materials}</span>
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <span className="text-3xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>{product.price}</span>
                    <button
                      onClick={() => handleProductClick(product)}
                      className="bg-[#B97A72] text-white px-8 py-3 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer flex items-center"
                      style={{ fontFamily: 'Playfair Display, serif' }}
                    >
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-eye-line"></i>
                      </div>
                      Voir le produit
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </section>
        </div>
      </main> */}

      {/* Advantages Section */}
      <section className="py-20 bg-[#EBD2CF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <article className="text-center">
              <div className="w-16 h-16 bg-[#B97A72] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#6B5E5A] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>Fait main</h3>
              <p className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Chaque ange est créé à la main avec patience et minutie dans mon atelier.
              </p>
            </article>
            
            <article className="text-center">
              <div className="w-16 h-16 bg-[#B97A72] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#6B5E5A] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>Éthique</h3>
              <p className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Créations durables à partir de livres recyclés, pour une déco responsable.
              </p>
            </article>
            
            <article className="text-center">
              <div className="w-16 h-16 bg-[#B97A72] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-gift-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-[#6B5E5A] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>Cadeau unique</h3>
              <p className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Des présents originaux qui apportent poésie et tendresse à Noël.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#B97A72] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Allura, cursive' }}>
            Découvrez toutes mes créations
          </h2>
          <p className="text-xl mb-8 opacity-90" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Au-delà des anges de Noël, explorez tout l'univers poétique des Carnets de Lolotte
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/boutique"
              className="inline-flex items-center justify-center px-8 py-3 bg-white text-[#B97A72] font-semibold rounded-full hover:bg-[#F8EDEA] transition-colors whitespace-nowrap cursor-pointer border-2 border-white"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Voir le catalogue complet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-3 border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-[#B97A72] transition-colors whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Me contacter
              <i className="ri-mail-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Footer Message */}
      <footer className="py-8 bg-[#FAF9F8] text-center">
        <p className="text-lg text-[#B97A72] font-medium italic" style={{ fontFamily: 'Playfair Display, serif' }}>
          ✨ Creations artisanales éthiques et poétiques – Les carnets de Lolotte ✨
        </p>
      </footer>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 transition-colors"
            >
              <i className="ri-close-line"></i>
            </button>
            <img
              src={selectedImage}
              alt="Image agrandie"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
}
